<template>
  <v-container fluid>
    <v-row>
      <v-col
        cols="12"
        md="10"
        offset-md="1"
        lg="10"
        offset-lg="1"
        xl="8"
        offset-xl="2"
      >
        <template v-if="showSkeleton">
          <v-skeleton-loader
            class="mb-6"
            type="card-avatar, article, list-item-avatar, list-item-avatar"
          ></v-skeleton-loader>
        </template>
        <template v-if="!showSkeleton && items.length > 0">
          <div class="contentHeader mb-4 mb-6">{{ InstructorTitle }}</div>
          <template v-if="!listMode">
            <v-row align="stretch">
              <template v-for="(item, idx) of items">
                <v-col cols="12" md="6" lg="3" :key="`col_instructor_${idx}`">
                  <v-hover v-slot="{ hover }">
                    <v-card
                      class="hoverable card-growable"
                      :style="{ height: '100%' }"
                      :elevation="hover ? 6 : 2"
                      @click="instructor(item._id)"
                      :color="hover ? 'primary--text' : ''"
                      ripple
                    >
                      <div class="text-center py-4">
                        <v-avatar size="72">
                          <v-img
                            :src="item.image"
                            :lazy-src="item.image"
                          ></v-img>
                        </v-avatar>
                      </div>
                      <v-list-item two-line>
                        <v-list-item-content>
                          <v-list-item-title class="subtitle-1 text-center">
                            {{ item.displayName }}
                          </v-list-item-title>
                          <v-list-item-subtitle>{{
                            item.description ? item.description : "-"
                          }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>

                      <!-- <v-card-title
                        class="subtitle-1"
                        v-text="item.displayName"
                      ></v-card-title>

                      <v-card-text
                        style="max-height: 40px; overflow-y: hidden"
                        class="mb-4"
                        >{{ item.description }}</v-card-text
                      > -->
                    </v-card>
                  </v-hover>
                </v-col>
              </template>
            </v-row>
          </template>
          <template v-else>
            <v-list class="py-0 mt-2" dense tile>
              <v-list-item
                v-for="(item, j) of items"
                :key="`instructor_${j}`"
                :class="{ 'has-border-top': j > 0 }"
                @click="instructor(item._id)"
              >
                <v-list-item-avatar>
                  <v-avatar>
                    <v-img :src="item.image" :lazy-src="item.image"></v-img>
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>{{
                  item.displayName
                }}</v-list-item-content>
                <v-list-item-action>
                  <v-btn icon>
                    <v-icon>far fa-chevron-right</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </template>
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    showSkeleton: true,
    items: [],
    loading: false,
    InstructorTitle: "",
  }),
  computed: {
    listMode() {
      if (this.$vuetify.breakpoint.mdAndDown) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.fetch();
    },
    fetch() {
      this.showSkeleton = true;
      this.InstructorTitle = this.$route.query.title;
      this.createRequest()
        .then((resp) => {
          if (resp.status == 200 && resp.data.status) {
            this.items = resp.data.result.elements;
          } else {
            // notify err
          }
        })
        .catch((err) => {
          // this.items = [];
          // notify err
        })
        .finally(() => {
          this.showSkeleton = false;
        });
    },
    createRequest() {
      // let sortBy = this.$route.query.sort || "created_at";
      // let sortOrder = this.$route.query.sortby || "-1";
      // let page = this.$route.query.page || "1";
      // let limit = this.$route.query.limit || "10";
      let qs = this.$utility.vueRouterQueryToJson(this.$route.query);
      return this.$http.get(
        `${
          this.$store.state.api
        }/home/teacher?${this.$utility.routerQueryStringToUrlParams(qs)}`
      );
    },
    instructor(id) {
      this.$router.push({
        name: "instructor",
        params: {
          id: id,
          isHorizental: true,
        },
      });
    },
    seeMore() {},
  },
};
</script>
<style scoped>
.contentHeader {
  font-size: 26px;
  font-weight: bold;
  color: #000000;
}
</style>